module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"assignToMe":"Assign to me","assigning":"Assigning..."},"et":{"assignToMe":"Assign to me","assigning":"Assigning..."},"ru":{"assignToMe":"Assign to me","assigning":"Assigning..."}}')
  delete Component.options._Ctor
}
